
<div [ngClass]="setDynamicClasses()">
    <p>
        <input (change)="onToggle(todo)" type="checkbox">
        {{ todo?.title }}
        <button (click)="onDelete(todo)" class="del">X</button>
    </p>
</div>